import {
  useLocation,
  useNavigate,
  useMatch,
  NavigationType,
  useNavigationType,
} from 'react-router-dom';
import { MESSAGE_CANCEL_REQUEST } from '../utils/constants/api-constants';

export const useHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const history = useNavigationType();

  const navigateTo = (path) => {
    if (path !== MESSAGE_CANCEL_REQUEST) {
      navigate(path);
    }
  };

  return {
    navigate: navigateTo,
    location,
    history,
    NavigationType,
    useMatch,
    useNavigationType,
  };
};
